import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Localize, DimensionFamilySelect, Switch } from '../shared';

import Select from 'react-select';

import {
  getIcon,
  getCountryIcon,
  getDimensionFamilyFromId,
  getDimensionsForFamily,
} from '../../util';

import {
  getLanguageKeys
} from '../../util/data';

const NEW_QUESTION = {
  questionFormat: null,
  questionType: null,
  status: 'disabled',
  experimentId: "",
  legacyId: null,
  categoryId: null,
  dimensionId: null,
  text: "",
  reverseScore: false,
  visible: false,
  questionIndex: 0,
}

class EditQuestionModal extends Component{

  state = {
    visible: false,
    question: null,
    editingForLanguage: 'en',
  }

  componentDidUpdate(prevProps, prevState){
    //if question updated in props
    if(!this.state.question && this.props.question){

      let questionForState = {};

      //new question
      if(this.props.question.id === 'new' || !this.props.question.id){
        questionForState = _.cloneDeep({
          ...NEW_QUESTION,
          id: 'new'
        });
      }
      else{
        questionForState = _.cloneDeep(this.props.question);
      }

      this.setState({
        question: questionForState,
        editingForLanguage: 'en',
      });
    }
    if(!this.props.question && this.state.question){
      this.setState({
        question: null,
        editingForLanguage: 'en',
      });
    }
  }

  updateQuestionProps(newProps){
    if(!this.props.editable){
      return;
    }

    this.setState({
      question: {
        ...this.state.question,
        ...newProps
      }
    });
  }
  updateQuestionProp(propName, newValue){

    if(!this.props.editable){
      return;
    }

    this.setState({
      question: {
        ...this.state.question,
        [propName]: newValue
      }
    });
  }

  getChoiceText(index){
    const {
      question,
      editingForLanguage
    } = this.state;

    if(editingForLanguage !== 'en' && question.localizations && question.localizations[editingForLanguage] && question.localizations[editingForLanguage][`choice_${index}`]){
      return question.localizations[editingForLanguage][`choice_${index}`];
    }
    else{
      return (question.choices && question.choices[index] && question.choices[index].text) ? question.choices[index].text : '';
    }
  }

  updateQuestionChoiceText(index, newText){
    const {
      question,
      editingForLanguage
    } = this.state;

    const existingChoiceData = {
      text: '',
      value: 0,
      ...((this.state.question.choices || {})[index] || {}),
    }

    if(editingForLanguage !== 'en'){

      const existingLocalizations = {
        ...question.localizations
      };

      this.updateQuestionProp('localizations', {
        ...existingLocalizations,
        [editingForLanguage]: {
          ...existingLocalizations[editingForLanguage],
          [`choice_${index}`]: newText
        }
      });
    }
    else{
      this.updateQuestionProp('choices', {
        ...question.choices,
        [index]: {
          ...existingChoiceData,
          text: newText
        }
      });
    }
  }
  updateQuestionChoiceValue(index, newValue){

    const existingChoiceData = {
      text: '',
      value: 0,
      ...((this.state.question.choices || {})[index] || {}),
    }

    this.updateQuestionProp('choices', {
      ...this.state.question.choices,
      [index]: {
        ...existingChoiceData,
        value: newValue
      }
    });
  }

  toggleDimensionScoring(dimensionsInFamily, dimensionId, on){
    let questionScoredDimensions = _.cloneDeep(this.state.question.scoredDimensions);

    if(on){
      questionScoredDimensions.push(dimensionId);
    }
    else{
      questionScoredDimensions = _.without(questionScoredDimensions, dimensionId);
    }

    let orderPreservedQuestionScoredDimensions = [];

    _.each(_.map(dimensionsInFamily, 'id'), orderedDimension => {
      if(questionScoredDimensions.indexOf(orderedDimension) > -1){
        orderPreservedQuestionScoredDimensions.push(orderedDimension);
      }
    })

    this.updateQuestionProp('scoredDimensions', orderPreservedQuestionScoredDimensions);
  }

  renderDimensionsForFamily(){
    const { dimensionFamily } = this.state.question;

    const dimensionsInFamily = getDimensionsForFamily(dimensionFamily);

    return (
      <React.Fragment>
        <div className="question-options-label"><small>Scored Dimensions</small></div>
        {_.map(dimensionsInFamily, dimension => {
          return (
            <div
              key={`question-switch-for-dimensions-${dimension.id}`}
              className="question-switch dimension-scored-switch"
            >
              <div className="switch-label">{dimension.label}</div>
              <Switch
                disabled={dimensionsInFamily.length === 1 || !this.props.editable}
                checked={this.state.question.scoredDimensions.indexOf(dimension.id) > -1 || false}
                onChange={checked => { this.toggleDimensionScoring(dimensionsInFamily, dimension.id, checked); } }
              />
            </div>
          )
        })}
      </React.Fragment>
    )
  }

  updateDimensionFamily(newDimensionFamily){

    //automatically score all dimensions components in family by default
    this.updateQuestionProps({
      dimensionFamily: newDimensionFamily,
      scoredDimensions: getDimensionFamilyFromId(newDimensionFamily).allDimensions
    });
  }

  renderDimensions(){

    const { questionType, dimensionFamily } = this.state.question;

    return(
      <div className="question-options-section dimension-scoring">
        <div className="question-options-label">Dimension Family</div>

        <DimensionFamilySelect
          disabled={!this.props.editable}
          style={{zIndex: 3}}
          currentDimensionFamily={dimensionFamily}
          changeDimensionFamily={newDimensionFamily => { this.updateDimensionFamily(newDimensionFamily); } }
        />

      {dimensionFamily && this.renderDimensionsForFamily()}
      </div>
    )
  }

  renderLikertReverseDirectionOption(){
    const {
      question
    } = this.state;

    const reverseScore = question.reverseScore || false;

    return (
      <div className="question-switch">
        <div className="switch-label">Reverse Likert Scoring Direction</div>
        <Switch
          disabled={!this.props.editable}
          id="likert-direction"
          checked={reverseScore || false}
          onChange={checked => { this.updateQuestionProp('reverseScore', checked); } }
        />
      </div>
    )
  }

  renderQuestionFormat(){

    const { questionFormat } = this.state.question;

    return(
      <div className="question-options-section">
        <div className="question-options-label">Question Format</div>
        <div className="question-options">
          <div
            onClick={() => { this.updateQuestionProp('questionFormat', 'likert'); }}
            className={`question-option ${questionFormat === 'likert' && 'selected'}`}
          >
            {getIcon('likert')}
            <h6>LIKERT</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('questionFormat', 'choice'); }}
            className={`question-option ${questionFormat === 'choice' && 'selected'}`}
          >
            {getIcon('multiple-choice')}
            <h6>MULTIPLE CHOICE</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('questionFormat', 'freeform'); }}
            className={`question-option ${questionFormat === 'freeform' && 'selected'}`}
          >
            {getIcon('freeform')}
            <h6>FREEFORM</h6>
          </div>
        </div>
      </div>
    )
  }

  renderQuestionScoring(){

    const { status } = this.state.question;

    return(
      <div className="question-options-section">
        <div className="question-options-label">Status</div>
        <div className="question-options experimental-options three-wide">
          <div
            onClick={() => { this.updateQuestionProp('status', 'disabled'); }}
            className={`question-option ${status === 'disabled' && 'selected'} disabled`}
          >
            <h6>DISABLED</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('status', 'experimental'); }}
            className={`question-option ${status === 'experimental' && 'selected'} experimental`}
          >
            <h6>EXPERIMENTAL</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('status', 'live'); }}
            className={`question-option ${status === 'live' && 'selected'} live`}
          >
            <h6>LIVE</h6>
          </div>
        </div>
      </div>
    )
  }

  renderExperimentId(){
    const { experimentId } = this.state.question;

    return(
      <div className="question-options-section">
        <div className="question-options-label">Experiment Id (optional)</div>
        <input
          className="question-option-text"
          type="text"
          placeholder="Optional Id"
          value={experimentId || ''}
          onChange={e => { this.updateQuestionProp('experimentId', e.target.value); }}
          />
      </div>
    )
  }

  renderAssessmentSection(){

    const { questionType } = this.state.question;

    return(
      <div className="question-options-section">
        <div className="question-options-label">Assessment Section<br/><small>(Currently not used for ordering)</small></div>
        <div className="question-options four-wide">
          <div
            onClick={() => { this.updateQuestionProp('questionType', 'talent'); }}
            className={`question-option ${questionType === 'talent' && 'selected'}`}
          >
            <h6>TALENT</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('questionType', 'skill'); }}
            className={`question-option ${questionType === 'skill' && 'selected'}`}
          >
            <h6>SKILL</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('questionType', 'experience'); }}
            className={`question-option ${questionType === 'experience' && 'selected'}`}
          >
            <h6>EXPERIENCE</h6>
          </div>
          <div
            onClick={() => { this.updateQuestionProp('questionType', 'post'); }}
            className={`question-option ${questionType === 'post' && 'selected'}`}
          >
            <h6>POST</h6>
          </div>
        </div>
      </div>
    )
  }

  questionPropsValid(){
    const {
      id,
      questionFormat,
      questionType,
      status,
      experimentId,
      legacyId,
      categoryId,
      dimensionId,
      text,
      reverseScore,
      dimensionFamily,
      scoredDimensions
    } = this.state.question;

    return status !== null && questionFormat !== null && questionType !== null && text !== '' && (status !== 'live' || scoredDimensions.length > 0);
  }

  renderActions(){

    const {
      question
    } = this.state;

    const {
      status,
      id,
    } = question;

    if(this.props.editable){
      if(id === 'new'){
        return (
          <div className="modal-actions">
            <button
              disabled={!this.questionPropsValid()}
              onClick={() => { this.props.createQuestion(this.state.question); } }
              className={`button ${status === 'experimental' ? 'pink-button' : (status === 'live' ? 'blue-button' : 'light-blue-button')}`}
            >Add Question</button>
            <button onClick={this.props.hide} className="button grey-outline">Cancel</button>
          </div>
        )
      }
      else{
        return (
          <div className="modal-actions">
            <button
              disabled={!this.questionPropsValid()}
              onClick={() => { this.props.updateQuestion(this.state.question); } }
              className={`button ${status === 'experimental' ? 'pink-button' : (status === 'live' ? 'blue-button' : 'light-blue-button')}`}
            >Update</button>
            <button onClick={this.props.hide} className="button grey-outline">Cancel</button>
          </div>
        )
      }
    }
    else{
      return (
        <div className="modal-actions">
          <button onClick={this.props.hide} className="button blue-button">Done</button>
        </div>
      )
    }
  }

  renderQuestionPreview(){

    const textIsEditable = this.state.question.id == 'new';

    const questionFormat = this.state.question.questionFormat;

    if(textIsEditable){
      return (
        <div className="question-options-section preview">
          <div className="question-options-label">Question Text</div>
          <textarea
            value={this.state.question.text}
            onChange={e => { this.updateQuestionProp('text', e.target.value); }}
          ></textarea>
          <p>This text will be displayed to all languages that do not have localizations configured for this question.</p>
          {questionFormat === 'choice' &&
            <React.Fragment>

            </React.Fragment>
          }
        </div>
      )
    }
    else{
      const questionId = this.state.question.id;
      const localizationId = `question_${questionId}_text`;

      return (
        <div className="question-options-section preview">
          <div className="question-options-label">Question Preview</div>
          <div className="localization-previews">
            {_.map(getLanguageKeys(), locale => {
              return (
                <div
                  key={`preview-for-language-${locale}`}
                  className="preview-for-language">{getCountryIcon(locale)}<Localize id={localizationId} locale={locale}><span style={{opacity: .35}}>(Localization not found)</span></Localize></div>
              )
            })}
          </div>
        </div>
      )
    }
  }

  renderQuestionChoices(){

    const {
      question
    } = this.state;

    let {
      choices,
    } = question;

    const defaultChoices = {
      'A': {
        text: '',
        value: 0
      },
      'B': {
        text: '',
        value: 0
      },
      'C': {
        text: '',
        value: 0
      },
      'D': {
        text: '',
        value: 0
      }
    }

    const choicesToRender = {
      ...defaultChoices,
      ...(choices || {})
    }

    return (
      <React.Fragment>
        <div className="question-choices">
          <div className="column-labels">
            <div className="choice-index">Index</div>
            <div className="choice-text">Text</div>
            <div className="choice-value">Value</div>
          </div>
          {_.map(choicesToRender, (choice, index) => {
            return (
              <div key={`question-choice-no-${index}`} className="question-choice">
                <div className="choice-index">{index}</div>
                <input
                  className="choice-text"
                  value={this.getChoiceText(index)}
                  onChange={e => { this.updateQuestionChoiceText(index, e.target.value); } }
                />
                <input
                  className="choice-value"
                  value={choice.value}
                  onChange={e => { this.updateQuestionChoiceValue(index, e.target.value); }}
                />
              </div>
            )
          })}
        </div>
      </React.Fragment>
    )
  }

  render(){

    const {
      visible,
      dimensions
    } = this.props;

    const {
      question
    } = this.state;

    if(!visible || !question){
      return null;
    }

    const {
      id,
      status,
      questionFormat,
    } = question;

    return (
      <div className={`modal edit-question ${!this.props.editable && 'readonly'}`}>
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            <div className={`question-id ${status}`}>&nbsp;{id}&nbsp;</div>

            {this.renderQuestionScoring()}
            {status === 'disabled' &&
              <span className={`scoring-explanation disabled`}>Disabled questions are neither shown nor scored. You can add & edit disabled questions freely without affecting the current assessment version.</span>
            }
            {status === 'experimental' &&
              <span className={`scoring-explanation experimental`}>Experimental questions are not scored in any reports, but are visible to assessment takers and tracked for research purposes.</span>
            }
            {status === 'live' &&
              <span className={`scoring-explanation live`}>Live questions are visible to all assessment takers and are scored for the associated dimensions.</span>
            }
            {status === 'experimental' && this.renderExperimentId()}
            {this.renderAssessmentSection()}
            {this.renderQuestionFormat()}
            {questionFormat === 'likert' && this.renderLikertReverseDirectionOption()}
            {this.renderDimensions()}

            {this.renderQuestionPreview()}

          </div>
          {this.renderActions()}
        </div>
      </div>
    )
  }
}

export default EditQuestionModal;



// WEBPACK FOOTER //
// ./src/components/modals/editQuestion.js